<template>
  <div class="warp12">
    <div class="statusBox">
      <cent-logo></cent-logo>
      <div class="personal infoBox">
        <!--        <div class="title">电子合同</div>-->
        <div class="content">
          <div class="formBox">
            <el-form
              :model="personalForm"
              :rules="personalRules"
              :label-position="'left'"
              ref="ruleForm" label-width="100px" class="ruleForm">
              <div class="formTit">
                <span class="serialNumber">01</span>
                <span class="formName">账号信息</span>
              </div>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="游戏名称" prop="gameId" class="idType">
                    <el-select v-model="personalForm.gameId" filterable placeholder="请选择">
                      <el-option
                        v-for="item in gameList"
                        :key="item.dictCode"
                        :label="item.dictLabel"
                        :value="item.dictValue">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="游戏账号" prop="gameAccount">
                    <el-input maxlength="100" placeholder="请输入游戏账号" v-model="personalForm.gameAccount"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="登录密码" prop="pwd">
                    <el-input maxlength="11" placeholder="请输入登录密码" v-model="personalForm.pwd"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="绑定手机" prop="bindPhone">
                    <el-input maxlength="100" placeholder="请输入绑定手机号" v-model="personalForm.bindPhone"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="登录设备" prop="device">
                    <el-input maxlength="100" placeholder="请输入账号登录设备" v-model="personalForm.device"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="历史充值" prop="amount">
                    <el-input maxlength="100" placeholder="请输入账号上次充值金额" v-model="personalForm.amount"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="近期游戏" prop="played">
                    <el-input maxlength="100" placeholder="请输入账号近期玩的游戏" v-model="personalForm.played"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="常玩地址" prop="login">
                    <el-input maxlength="100" placeholder="请输入常登陆地址" v-model="personalForm.login"></el-input>
                  </el-form-item>
                </el-col>


              </el-row>

              <el-row style="margin-top: 20px">
                <el-col :span="12">
                  <el-form-item class="prove" label-width="120px" label="防沉谜截图" prop="riddleImg">
                    <div class="idImgesBox">
                      <div class="idImgaeLeft">
                        <el-upload
                          list-type="picture-card"
                          :action="action"
                          :headers="myHeaders"
                          :show-file-list="false"
                          :on-success="handleHandHeld">
                          <img v-if="personalForm.riddleImg" :src="personalForm.riddleImg" class="avatar">
                          <div v-else class="noImg">
                            <div class="bgBox">
                              <img src="../../assets/images/fcmdm.png" alt="">
                            </div>
                          </div>
                          <div class="changeImg">选择</div>
                          <div class="bgInfo">防沉谜截图</div>
                        </el-upload>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label-width="120px" label="网购截图" prop="extra3">
                    <div class="idImgesBox">
                      <div class="idImgaeLeft">
                        <el-upload
                          list-type="picture-card"
                          :action="action"
                          :headers="myHeaders"
                          :show-file-list="false"
                          :on-success="handleHandExtra">
                          <img v-if="personalForm.extra3" :src="personalForm.extra3" class="avatar">
                          <div v-else class="noImg">
                            <div class="bgBox">
                              <img src="../../assets/images/wmdemo.png" alt="">
                            </div>
                          </div>
                          <div class="changeImg">选择</div>
                          <div class="bgInfo">网购截图</div>
                          <!--                          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>-->
                        </el-upload>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <div class="formTit">
                <span class="serialNumber">02</span>
                <span class="formName">号主信息</span>
              </div>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="姓名" prop="name">
                    <el-input maxlength="100" placeholder="请输入姓名" v-model="personalForm.name"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="身份证号" prop="card">
                    <el-input maxlength="100" placeholder="请输入身份证号" v-model="personalForm.card"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="联系电话" prop="linkPhone">
                    <el-input maxlength="100" placeholder="请输入联系电话" v-model="personalForm.linkPhone"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="联系微信" prop="lwechat">
                    <el-input maxlength="100" placeholder="请输入联系微信" v-model="personalForm.lwechat"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="邮箱账号" prop="email">
                    <el-input maxlength="100" placeholder="请输入邮箱账号" v-model="personalForm.email"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="常住地址" prop="address">
                    <el-input maxlength="100" placeholder="请输入常住地址" v-model="personalForm.address"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="收款方式" prop="collection">
                    <el-input maxlength="100" placeholder="请输入收款支付宝/微信账号" v-model="personalForm.collection"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>


              <div class="formTit">
                <span class="serialNumber">03</span>
                <span class="formName">身份证照片</span>
              </div>
              <el-row style="margin-top: 20px">
                <el-col :span="12">
                  <el-form-item class="prove" label-width="120px" label="身份证人像面" prop="cardFront">
                    <div class="idImgesBox">
                      <div class="idImgaeLeft">
                        <el-upload
                          list-type="picture-card"
                          :action="action"
                          :headers="myHeaders"
                          :show-file-list="false"
                          :on-success="handleIdPositive">
                          <img v-if="personalForm.cardFront" :src="personalForm.cardFront" class="avatar">
                          <div v-else class="noImg">
                            <div class="bgBox">
                              <img src="../../assets/images/yingyezhiz@2x.png" alt="">
                            </div>
                          </div>
                          <div class="changeImg">选择</div>
                          <div class="bgInfo">身份证人像面</div>
                        </el-upload>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label-width="120px" label="身份证国徽面" prop="cardBack">
                    <div class="idImgesBox">
                      <div class="idImgaeLeft">
                        <el-upload
                          list-type="picture-card"
                          :action="action"
                          :headers="myHeaders"
                          :show-file-list="false"
                          :on-success="handleIdBack">
                          <img v-if="personalForm.cardBack" :src="personalForm.cardBack" class="avatar">
                          <div v-else class="noImg">
                            <div class="bgBox">
                              <img src="../../assets/images/yingyezhiz@2x.png" alt="">
                            </div>
                          </div>
                          <div class="changeImg">选择</div>
                          <div class="bgInfo">身份证国徽面</div>
                          <!--                          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>-->
                        </el-upload>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>


              <!--
                            <el-form-item label="证件照片" prop="cardFront">
                              <span>需与当地政府颁发的商业许可证书或企业注册证上的企业名称完全一致，信息审核审核成功后企业名称不可修改</span>
                              <div class="idImgesBox" style="margin-top: 14px">
                                <div class="idImgaeLeft">
                                  <el-upload
                                    list-type="picture-card"
                                    :action="action"
                                    :headers="myHeaders"
                                    :show-file-list="false"
                                    :on-success="handleIdPositive">
                                    <img v-if="personalForm.cardFront" :src="personalForm.cardFront" class="avatar">
                                    <div v-else class="noImg">
                                      <div class="bgBox">
                                        <img src="../../assets/images/shenfenz@2x.png" alt="">
                                      </div>
                                    </div>
                                    <div class="changeImg" style="top: 104px; left: 147px;">选择</div>
                                    <div class="bgInfo">身份证人像面</div>
                                  </el-upload>
                                </div>
                                <div class="idImgaeRight">
                                  <el-upload
                                    list-type="picture-card"
                                    :action="action"
                                    :headers="myHeaders"
                                    :show-file-list="false"
                                    :on-success="handleIdBack">
                                    <img v-if="personalForm.cardBack" :src="personalForm.cardBack" class="avatar">
                                    <div v-else class="noImg">
                                      <div class="bgBox">
                                        <img src="../../assets/images/shenfenzb@2x.png" alt="">
                                      </div>
                                    </div>
                                    <div class="changeImg" style="top: 104px; left: 751px;">选择</div>
                                    <div class="bgInfo">身份证国徽面</div>
                                  </el-upload>
                                </div>
                              </div>
                            </el-form-item>-->
              <div class="formTit">
                <span class="serialNumber">04</span>
                <span class="formName">亲友联系方式</span>
              </div>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="亲友类型" prop="relationShip" class="idType">
                    <el-select v-model="personalForm.relationShip" placeholder="请选择">
                      <el-option
                        v-for="item in relationShipData"
                        :key="item.dictCode"
                        :label="item.dictLabel"
                        :value="item.dictValue">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="亲友名称" prop="extra1">
                    <el-input placeholder="请输入亲友名称" v-model="personalForm.extra1"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="亲友手机" prop="extra2">
                    <el-input placeholder="请输入亲友手机" v-model="personalForm.extra2"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="验证码" prop="code">
                    <el-input placeholder="请输入验证码" v-model="personalForm.code">
                      <template #suffix>
                        <el-button :disabled="countdown > 0" @click="startCountdown">
                          <span class="codeBtn">{{ countdown > 0 ? countdown + '秒' : '发送验证码' }}</span>
                        </el-button>
                      </template>
                    </el-input>
                  </el-form-item>

                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div class="dexData">亲友姓名号码会联合公网自动校验，不匹配直接取消交易。</div>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <el-button @click="submitForm('ruleForm')" class="submitBtn" type="primary">提交</el-button>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>
  // import  BMap from  'bmap'
  import CentLogo from '@/components/centLogo'
  import api from '@/api'
  import {listSearchMixin} from '@/config/mixin'
  import {regionData, CodeToText} from 'element-china-area-data'
  // import Cookie from 'js-cookie'
  export default {
    name: 'individualBusiness',
    mixins: [listSearchMixin],
    components: {CentLogo},
    data() {
      return {
        countdown: 0,
        timer: null,
        relationShipData: [],
        options: regionData,
        selectedOptions: [],
        registeredAddress: [],
        personalForm: {
          relationShip: '',//亲友类型
          key: '',//验证码key
          code: '',//验证码值
          extra1: '',
          extra2: '',
          extra3: '',
          gameId: '',
          gameAccount: '',
          pwd: '',
          bindPhone: '',
          name: '',
          card: '',
          linkPhone: '',
          lwechat: '',
          email: '',
          address: '',
          mapAddress: '',
          longitude: '',
          latitude: '',
          riddleImg: '',
          cardFront: '',
          cardBack: '',
          collection: '',
          device: '',
          amount: '',
          played: '',
          login: '',
          shopName: '', // 店铺名称
          shopPhone: '', // 手机号
          servicePhone: '', // 客服电话
          chargePersonName: '', // 店铺负责人
          chargePersonPhone: '', // 负责人电话
          shopAdress: '', // 店铺地址
          shopAdressProvince: '', // 店铺地址省
          shopAdressCity: '', // 店铺地址市
          storeAddressDetail: '', // 店铺详细地址
          otherName: '', // 组织名称
          otherCode: '', // 组织机构代码
          otherRegion: '', // 注册地址 省-市-区
          otherAdress: '', // 注册地址详细
          otherStartTime: '', // 营业期限开始时间
          otherEndTime: '', // 营业期限结束时间
          otherLicense: '', // 机构证件或其他证明材料图片地址
          otherOperator: '', // 负责人姓名
          otherCardType: '', // 身份证类型
          otherIdCard: '', // 负责人身份证号码
          otherCardStartTime: '', // 证件有效开始时间
          otherCardEndTime: '', // 证件有效结束时间
          otherCardPositive: '', // 身份证正面照
          otherCardSide: '' // 身份证反面照
        },
        idCardList: [],
        gameList: [],
        dictName: '证件类型',
        isShowImg: true,
        personalRules: {
          relationShip: [{required: true, message: '请选择亲友类型', trigger: 'blur'}],
          code: [{required: true, message: '请输入验证码值', trigger: 'blur'}],
          extra1: [{required: true, message: '请输入亲友名称', trigger: 'blur'}],
          extra2: [{required: true, message: '请输入亲友手机号', trigger: 'blur'}],
          extra3: [{required: true, message: '请输入网购截图', trigger: 'blur'}],
          gameId: [{required: true, message: '请选择游戏', trigger: 'blur'}],
          gameAccount: [{required: true, message: '请输入游戏账号', trigger: 'blur'}],
          pwd: [{required: true, message: '请输入登录密码', trigger: 'blur'}],
          bindPhone: [{required: true, message: '请输入绑定手机号', trigger: 'blur'}],
          name: [{required: true, message: '请输入姓名', trigger: 'blur'}],
          card: [{required: true, message: '请输入身份证号', trigger: 'blur'}],
          linkPhone: [{required: true, message: '请输入联系电话', trigger: 'blur'}],
          lwechat: [{required: true, message: '请输入联系微信', trigger: 'blur'}],
          email: [{required: true, message: '请输入邮箱', trigger: 'blur'}],
          address: [{required: true, message: '请输入常住地址', trigger: 'blur'}],
          riddleImg: [{required: true, message: '请上传防沉谜图片', trigger: 'blur'}],
          cardFront: [{required: true, message: '请上传身份证正面图片', trigger: 'blur'}],
          cardBack: [{required: true, message: '请上传身份证背面图片', trigger: 'blur'}],
          device: [{required: true, message: '请输入账号登录设备', trigger: 'blur'}],
          amount: [{required: true, message: '请输入账号上次充值金额', trigger: 'blur'}],
          played: [{required: true, message: '请输入账号近期玩的游戏', trigger: 'blur'}],
          login: [{required: true, message: '请输入常登陆地址', trigger: 'blur'}],
          collection: [{required: true, message: '请输入收款支付宝/微信账号', trigger: 'blur'}]
        },
        dialogImageUrl: '',
        dialogVisible: false,
        imageUrl: '',
        action: api.upload,
        myHeaders: {}
      }
    },
    mounted() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      if (flag) {
        this.$router.push({path: '/mOtherOrg'})
      }
      this.getAddressIp()
      this.getDictList()
      this.getRelDictList()
    },
    methods: {
      resetData() {
        this.personalForm = {
          relationShip: '',//亲友类型
          key: '',//验证码key
          code: '',//验证码值
          extra1: '',
          extra2: '',
          extra3: '',
          gameId: '',
          gameAccount: '',
          pwd: '',
          bindPhone: '',
          name: '',
          card: '',
          linkPhone: '',
          lwechat: '',
          email: '',
          address: '',
          mapAddress: '',
          longitude: '',
          latitude: '',
          riddleImg: '',
          cardFront: '',
          cardBack: '',
          collection: '',
          device: '',
          amount: '',
          played: '',
          login: '',
        }
      },
      //获取当前登录地点
      getAddressIp() {
        const geolocation = new BMap.Geolocation();
        let _this = this
        geolocation.getCurrentPosition(function getinfo(position) {
          _this.personalForm.longitude = position.point.lng;
          _this.personalForm.latitude = position.point.lat;
          var point = new BMap.Point(position.point.lng, position.point.lat);
          var gc = new BMap.Geocoder();
          gc.getLocation(point, function (rs) {
            _this.personalForm.mapAddress = rs.address;
            console.log(rs.address);
          });
          let city = position.address.city;             //获取城市信息
          let province = position.address.province;     //获取省份信息

        }, function (e) {
        }, {provider: 'baidu'});
      },
      startCountdown() {
        let params = {
          url: api.sendCode,
          method: 'POST',
          data: this.personalForm
        }
        this.sendReq(params, (res) => {
          if (res.code === 200) {
            this.personalForm.key = res.data.uuid;
            this.countdown = 59;
            this.timer = setInterval(() => {
              if (this.countdown > 0) {
                this.countdown--;
              } else {
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          } else {
            this.$message({
              message: res.msg,
              type: 'error'
            })
          }
        })
      }
      ,
      beforeDestroy() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }
      ,
      getDictList() {
        let self = this
        let params = {
          url: api.getDictData + '/sys_game_type',
          method: 'GET'
        }
        self.sendReq(params, (res) => {
          if (res.code === 200) {
            self.gameList = res.data
          }
        })
      }
      ,
      getRelDictList() {
        let self = this
        let params = {
          url: api.getDictData + '/sys_relation_ship',
          method: 'GET'
        }
        self.sendReq(params, (res) => {
          if (res.code === 200) {
            self.relationShipData = res.data
          }
        })
      }
      ,
      handleIdPositive(res, file) {
        this.personalForm.cardFront = res.url
      }
      ,
      handleIdBack(res, file) {
        this.personalForm.cardBack = res.url
      }
      ,
      handleHandHeld(res, file) {
        this.personalForm.riddleImg = res.url
      }
      ,
      handleHandExtra(res, file) {
        this.personalForm.extra3 = res.url
      }
      ,
      addressChange(arr) {
        this.personalForm.shopAdress = `${CodeToText[arr[0]]}-${CodeToText[arr[1]]}-${CodeToText[arr[2]]}`
        this.personalForm.shopAdressProvince = CodeToText[arr[0]]
        this.personalForm.shopAdressCity = CodeToText[arr[1]]
      }
      ,
      registeredAddressChange(arr) {
        this.personalForm.otherRegion = `${CodeToText[arr[0]]}-${CodeToText[arr[1]]}-${CodeToText[arr[2]]}`
      }
      ,
      handlePictureCardPreview() {
        this.dialogImageUrl = this.idPositive
        this.dialogVisible = true
      }
      ,
      changeShopPone() {
        this.personalForm.shopPhone = this.personalForm.servicePhone
      }
      ,
      // 提交入驻
      submitForm(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            // alert('submit!')storeAddressDetail
            // this.personalForm.shopAdress = `${this.personalForm.shopAdress}，${this.personalForm.storeAddressDetail}`
            let params = {
              url: api.organizationsCheck,
              method: 'POST',
              data: this.personalForm
            }
            this.sendReq(params, (res) => {
              if (res.code === 200) {
                this.$message({
                  message: '提交成功',
                  type: 'success'
                })
                this.resetData();
                this.countdown = 0;
                // this.$router.push({path: '/status'})
              } else {
                this.$message({
                  message: res.msg,
                  type: 'error'
                })
              }
            })
          } else {
            this.$message({
              message: '信息填写不完整！',
              type: 'warning'
            })
            return false
          }
        })
      }
      ,
      resetForm(formName) {
        this.$refs[formName].resetFields()
      }
    }
  }
</script>


<style lang="scss" scoped>
  .dexData {
    /*color: #FFEBC4;*/
    font-size: 24px;
    margin-top: 10px;
    text-align: center;
  }

  .statusBox {
    .infoBox {
      width: 100%;
      height: 700px;
      background: #ffffff;

      .title {
        background: #FAFAFA;
        width: 100%;
        height: 42px;
        line-height: 42px;
        text-align: center;
        border-bottom: 1px solid #E6E6E6;
      }

      .content {
        width: 100%;
        padding: 0 80px 50px 80px;
        height: 650px;
        overflow-y: auto;

        .formTit {
          height: 55px;
          display: flex;
          align-items: center;
          width: 100%;
          margin: 40px 0;
          border-bottom: 1px solid #E6E6E6;

          .serialNumber {
            width: 24px;
            height: 24px;
            color: #C5AA7B;
            border: 1px solid #C5AA7B;
            border-radius: 4px;
            margin-right: 10px;
            text-align: center;
            line-height: 24px;
            font-size: 12px;
          }

          .formName {
            font-size: 20px;
            font-weight: 400;
            color: #333333;
            width: 200px;
          }
        }

        .formBox {
          width: 100%;

          .ruleForm {
            .el-form-item {
              padding: 0 20px;
            }
          }

          .el-cascader {
            width: 100%;
          }

          .idDateBox {
            margin-bottom: 30px;

            .el-form-item__content {
              display: flex;
            }
          }

          .describe {
            margin: 15px 0 30px 0;

            p {
              // padding-left: 150px;
              font-size: 12px;
              color: #999999;
            }
          }

          .idImgesBox {
            display: flex;
            justify-content: space-between;

            .idImgaeLeft {
              width: 50%;
            }

            .idImgaeRight {
              width: 50%;
              text-align: center;
            }

            .el-upload-list--picture-card {
              width: 284px;
              height: 180px;
            }

            .el-upload--picture-card {
              width: 284px;
              height: 180px;
              position: relative;

              .avatar {
                width: 231%;
                max-height: 178px;
              }

              .noImg {
                position: absolute;
                left: 0;
                // top: 0;
                // bottom: 0;
                // right: 0;
                background: #F7F7F7;

                .bgBox {
                  height: 149px;
                  align-items: center;
                  display: flex;
                  justify-content: center;
                }
              }

              .bgInfo {
                color: #FFFFFF;
                font-size: 14px;
                height: 39px;
                line-height: 39px;
                background: #A0C1FF;
                position: absolute;
                left: 0;
                bottom: -29px;
                width: 338px;
              }

              .changeImg {
                display: none;
                position: absolute;
                top: 49px;
                left: 146px;
                width: 60px;
                height: 60px;
                line-height: 60px;
                background: #000000;
                opacity: 0.6;
                border-radius: 50%;
                color: #FFFFFF;
              }

              .zoomImg {
                position: absolute;
                top: 40px;
                left: 50px;
                width: 60px;
                height: 60px;
                line-height: 60px;
                background: #000000;
                opacity: 0.6;
                border-radius: 50%;
                color: #FFFFFF;
              }

              &:hover {
                .changeImg {
                  display: block;
                }
              }
            }

            .el-upload-list--picture-card .el-upload-list__item {
              width: 284px;
              height: 180px;
            }
          }

          .businessDate {
            span {
              display: inline-block;
              text-align: center;
              width: 50px;
              color: #666666;
            }

            .el-date-editor--date {
              width: 268px;
            }
          }

          .idType {
            .el-select {
              width: 100%;
            }
          }
        }

        .submitBtn {
          display: block;
          width: 750px;
          height: 50px;
          margin: 40px auto 0 auto;
          color: #FFEBC4;
          background: #333333;
          box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.2);
        }
      }
    }

    .el-form-item__content {
      p {
        font-size: 12px;
        color: #999999;
        line-height: 20px;
        margin-top: 8px;
      }

      .el-input__inner, .el-textarea__inner {
        border-radius: 0;
        border: 1px solid transparent;
        color: #333;
        background: #F9F9F9;

        &:focus {
          border-color: #C5AA7B;
        }
      }
    }
  }

  .hide {
    .el-upload--picture-card {
      display: none;
    }
  }

  .avatar-uploader {
    img {
      width: 100%;
    }
  }

  .codeBtn {
    width: 120px;
    height: 40px;
    background: #C5AA7B;
    border-radius: 0;
    display: block;
    line-height: 40px;
    text-align: center;
    position: absolute;
    right: -5px;
    bottom: 1px;
    cursor: pointer;
    color: #FFFFFF;
  }

  ::v-deep {
    .statusBox {
      .content {
        .el-upload {
          border: none !important;
        }
      }
    }
  }


</style>



// WEBPACK FOOTER //
// src/views/SettleIn/organization.vue